import { useContext, useEffect, useState } from 'react'
import { getStudentFeedback } from '../feedbackApi'
import type { FeedbackOption, UseStudentFeedbackReturn } from '../feedbackTypes'
import { BookingContext } from 'contexts/booking'

const useStudentFeedback = (): UseStudentFeedbackReturn => {
    const booking = useContext(BookingContext)
    const [feedbackOptions, setFeedbackOptions] = useState<FeedbackOption[]>([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState<string | null>(null)

    useEffect(() => {
        const fetchFeedback = async (): Promise<void> => {
            try {
                if (booking.status === 'validated') {
                    setLoading(true)
                    setError(null)
                    const response = await getStudentFeedback(booking.auth)
                    if (response) {
                        setFeedbackOptions(response.feedbackOptions)
                    } else {
                        // API returned null, which indicates an error occurred
                        setError('Failed to load feedback')
                    }
                }
            } catch (err) {
                const errorMessage = err instanceof Error ? err.message : 'Failed to load feedback'
                setError(errorMessage)
                console.error('Failed to fetch student feedback:', err)
            } finally {
                setLoading(false)
            }
        }

        void fetchFeedback()
    }, [booking])

    return { feedbackOptions, loading, error }
}

export { useStudentFeedback }
